import { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useAuthContext } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function TestPaymentSubmit() {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string>('');

  if (user?.email !== 'viitamint@gmail.com') {
    navigate('/');
    return null;
  }

  const createTestPayment = async () => {
    setLoading(true);
    setResult('');
    
    try {
      const testPayment = {
        email: 'test@example.com',
        instructorEmail: 'test@example.com',
        amount: 299,
        plan: 'Pro',
        tier: 'Pro',
        status: 'pending',
        slipImageUrl: 'https://via.placeholder.com/400x600/FF6B6B/FFFFFF?text=Test+Slip',
        createdAt: serverTimestamp(),
        linkedToUser: false,
        testData: true
      };

      console.log('Creating test payment:', testPayment);
      const docRef = await addDoc(collection(db, 'subscriptionPayments'), testPayment);
      
      setResult(`✅ Success! Created payment with ID: ${docRef.id}`);
      console.log('✅ Test payment created:', docRef.id);
    } catch (error: any) {
      setResult(`❌ Error: ${error.message}`);
      console.error('❌ Error creating test payment:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Test Payment Submit</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-bold mb-4">Create Test Payment</h2>
          <p className="text-gray-600 mb-4">
            This will create a test payment record in the subscriptionPayments collection
            with status 'pending' so you can test the admin approval system.
          </p>
          
          <button
            onClick={createTestPayment}
            disabled={loading}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
          >
            {loading ? 'Creating...' : 'Create Test Payment'}
          </button>
          
          {result && (
            <div className={`mt-4 p-4 rounded ${
              result.startsWith('✅') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
            }`}>
              {result}
            </div>
          )}
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="font-bold mb-2">Next Steps:</h3>
          <ol className="list-decimal list-inside space-y-2 text-sm">
            <li>Click "Create Test Payment" button above</li>
            <li>Go to <a href="/admin" className="text-blue-600 underline">Admin Dashboard</a></li>
            <li>You should see a notification about pending payment</li>
            <li>Click the notification to go to Payment Approval page</li>
            <li>You should see the test payment there</li>
          </ol>
        </div>

        <div className="mt-6">
          <a
            href="/admin"
            className="text-blue-600 hover:underline"
          >
            ← Back to Admin Dashboard
          </a>
        </div>
      </div>
    </div>
  );
}
